<template>
  <div id="index" @click='mHideAll' >
    <app-nav :aidx="$route.auth.activeIndex" :astyle="$route.auth.style"></app-nav>
    <div class="container" data-myscroll="{{scroll}}">
      <div class="panel1" flex="main:center cross:center">
        <div class="bg" id="panel1" >
          <h1>在数字智能时代</h1>
          <h2>帮助品牌切换赛道到数字世界</h2>
          <h2>基于新经济规则做生意</h2>
          <!-- <img src="../static/images/com_index_1fig.png" alt=""> -->
          <div class="note">
            <p>欢迎探索</p>
            <p>品牌数字化新世界</p>
            <div class="arrow pcShow"><img src="../static/images/com_index_1arrow1.png" alt=""></div>
          </div>
        </div>
      </div>
      <div class="panel2 pcShow" >
        <div class="pic  ">
          <div class="txt_box">
            <div class="swiper-container5">
              <div class="swiper-wrapper">
                <div id="exp" class='swiper-slide'>
                  <h2>用户体验</h2>
                  <p>用户体验就是用户在与你的品牌互动的过程中获得满意度。</p>
                </div>
                <div id="dig_exp" class='swiper-slide'>
                  <h2>数字化用户体验</h2>
                  <p>数字化用户体验，就是如何赢得数字化用户的心、钱包、赞誉和衷心；是用户在不同时刻，通过各种数字接触点，与你的品牌互动过程中获得的体验。</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h1>用户体验是品牌连接用户的入口</h1>
        <div class="main top">
          <p>智能手机赋予用户至高的权力，</p>
          <p>消费者期望随时获得良好的、</p>
          <p>个性化的<span id='span_exp' >用户体验</span>,尤其是<span id='span_dig_exp'>数字化的用户体验</span>。</p>
        </div>
        <div class="main bottom">
          <p>用户体验受到的重视程度呈指数增长，</p>
          <p>因为它关系到品牌的繁荣和存亡。</p>
        </div>
      </div>
      <br class='pcShow'>
      <div class="panel2 phoneShow">
        <img class="textPic" src="../static/images/text_USER.png">
        <img class="textPic2" src="../static/images/text_Experience.png">

        <div class="entrance_phone">
          <h2>
            用户体验是品牌连接用户的入口：
            <!-- <span class="square3"></span> -->
          </h2>
          <p>
            智能手机赋予用户至高的权利，消费者期望随时获得良好的、个性化的<strong id="exp_toggle" @click.stop='mShow(0)'>用户体验</strong>，尤其是<strong id="dig_toggle" @click.stop='mShow(1)'>数字化用户体验</strong>。用户体验受到的重视程度呈指数级增长，因为它关系到品牌的繁荣和存亡。
          </p>
          <div class="exp_phone" id="panel2_exp_phone" @click.stop=''>
            <h2 class='theme'>
              用户体验：
              <!-- <span class="square1"></span> -->              
            </h2>
            <div class='main'>
              <p>用户体验就是用户在与你的品牌互动的过程中获得的满意度。</p>
            </div>
          </div>
          <div class="dig_exp_phone" id="panel2_dig_exp_phone" @click.stop=''>
            <h2 class='theme'>
              数字化用户体验：
              <!-- <span class="square2"></span> -->
            </h2>
            <div class='main'>
              <p>数字化用户体验，就是如何赢得数字化用户的心、钱包、赞誉和衷心；是用户在不同时刻，通过各种数字接触点，与你的品牌互动过程中获得的体验。</p>
            </div>
          </div>
        </div>

      </div>
      <div class="panel3 pcShow" flex="main:center cross:center">
        <div class="bg " flex="main:center cross:center">
          <div class="leftbox">
            <h2>用户的时代</h2>
            <p>
              世界经济发展的趋势，自1990年的信息时代，到2010年开始，进入了用户的时代。
            </p>
            <p>
              被赋予空前权力的消费者期望获得一种全新的用户体验。
            </p>
            <p>
              在未来的十几年里，大多数成功的企业将通过自我再造，系统化地理解和服务好强大的客户。
            </p>
          </div>
          <div class="rightbox ">
            <ul>
              <li flex="main:center cross:top" class="item">
                <div class="box">
                  <h3>
                    1900 制造的时代
                    <span></span>
                  </h3>
                  <p>大规模制造让规模化工业制造集团获得成功</p>
                  <ul>
                    <li>FORD</li>
                    <li>Boeing</li>
                    <li>GE</li>
                    <li>RCA</li>
                  </ul>
                </div>
              </li>
              <li flex="main:center cross:top" class="item">
                <div class="box">
                  <h3>
                    1960 流通的时代
                    <span></span>
                  </h3>

                  <p>全球的交通和运输系统使流通成为关键所在</p>
                  <ul>
                    <li>Wal-Mart</li>
                    <li>Toyota</li>
                    <li>P&G</li>
                    <li>UPS</li>
                  </ul>
                </div>
              </li>
              <li flex="main:center cross:top" class="item">
                <div class="box">
                  <h3>
                    1990 信息的时代
                    <span></span>
                  </h3>
                  <p>互联的电脑和供应链系统意味着那些控制信息流的公司获得统治</p>
                  <ul>
                    <li>Amazon</li>
                    <li>Google</li>
                    <li>Capital One</li>
                    <li>Disney</li>
                  </ul>
                </div>
              </li>
              <li flex="main:center cross:top" class="item">
                <div class="box">
                  <h3>
                    2010 用户的时代
                    <span></span>
                  </h3>
                  <p>被赋权的消费者需要一种全新的、令其痴迷的用户体验</p>
                  <ul>
                    <li>Macy’ s</li>
                    <li>Salesforce.com</li>
                    <li>MUJI</li>
                    <li>Amazon</li>
                    <li>Disney</li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="panel3 phoneShow" >

        <div class="leftbox">
          <h2>用户的时代</h2>
          <p>
            世界经济发展的趋势，自1990年的信息时代，到2010年开始，进入了用户的时代。
          </p>
          <p>
            被赋予空前权力的消费者期望获得一种全新的用户体验。
          </p>
          <p>
            在未来的十几年里，大多数成功的企业将通过自我再造，系统化地理解和服务好强大的客户。
          </p>
        </div>
        <div class="rightbox swiper-container7">
          <ul class='swiper-wrapper'>
            <li class="swiper-slide item ">
              <div class="box a1990">
                <h3>
                  1900 制造的时代
                  <span></span>
                </h3>
                <p>大规模制造让规模化工业制造集团获得成功</p>
                <ul>
                  <li>FORD</li>
                  <li>Boeing</li>
                  <li>GE</li>
                  <li>RCA</li>
                </ul>
              </div>
            </li>
            <li  class="swiper-slide item ">
              <!-- flex="main:center cross:{{msg}}" -->
              <div class="box a1960">
                <h3>
                  1960 流通的时代
                  <span></span>
                </h3>

                <p>全球的交通和运输系统使流通成为关键所在</p>
                <ul>
                  <li>Wal-Mart</li>
                  <li>Toyota</li>
                  <li>P&G</li>
                  <li>UPS</li>
                </ul>
              </div>
            </li>
            <li  class="swiper-slide item">
              <!-- flex="main:center cross:{{msg}}" -->
              <div class="box a1990">
                <h3>
                  1990 信息的时代
                  <span></span>
                </h3>
                <p>互联的电脑和供应链系统意味着那些控制信息流的公司获得统治</p>
                <ul>
                  <li>Amazon</li>
                  <li>Google</li>
                  <li>Capital One</li>
                  <li>Disney</li>
                </ul>
              </div>
            </li>
            <li  class="swiper-slide item">
              <!-- flex="main:center cross:{{msg}}" -->
              <div class="box a2010">
                <h3>
                  2010 用户的时代
                  <span></span>
                </h3>
                <p>被赋权的消费者需要一种全新的、令其痴迷的用户体验</p>
                <ul>
                  <li>Macy’ s</li>
                  <li>Salesforce.com</li>
                  <li>MUJI</li>
                  <li>Amazon</li>
                  <li>Disney</li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        
      </div>
      <div class="panel4 pcShow" >
        <div class="linechart">
          <div id="line_chart"  > <!-- style='transform: scale(0.5);' -->
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1"  id="svg_chart" width='1844' height='1004'>

            </svg>
            <img src="../static/images/panel4_icons/com_index_4icon1992.png" alt="" class="i1990 panel4_icon">
            <img src="../static/images/panel4_icons/com_index_4icon2003.png" alt="" class="i2003 panel4_icon">
            <img src="../static/images/panel4_icons/com_index_4icon2009.png" alt="" class="i2009 panel4_icon">
            <img src="../static/images/panel4_icons/com_index_4icon2012.png" alt="" class="i2012 panel4_icon">
            <img src="../static/images/panel4_icons/com_index_4icon2013.png" alt="" class="i2013 panel4_icon">
            <img src="../static/images/panel4_icons/com_index_4icon2014.png" alt="" class="i2014 panel4_icon">
            <img src="../static/images/panel4_icons/com_index_4icon2016.png" alt="" class="i2016 panel4_icon">
            <img src="../static/images/panel4_icons/com_index_4icon2020.png" alt="" class="i2020 panel4_icon">
          </div>
        </div>
        <div class="center">
          <h2 class="tada">万物互联</h2>
          <p>到2020年世界上将会有70亿人口，同时会有至少500亿台设备通过数字世界互相连接。</p>
          <p>这意味着，这个星球上的生意如果不能参与到这个互联互通的数字化世界，就将会被淘汰。</p>
        </div>
      </div>
      <div class="panel4 phoneShow">

        <div class="centerPart">
          <img class="textPic" src="../static/images/text_INTERNET.png"/>
          <img class="square" src="../static/images/square8.png"/>
          <img class="linePic" src="../static/images/lineShow.png"/>
        </div>
        <div class="center">
          <h2 class="tada">万物互联</h2>
          <p>到2020年世界上将会有70亿人口，同时会有至少500亿台设备通过数字世界互相连接。</p>
          <p>这意味着，这个星球上的生意如果不能参与到这个互联互通的数字化世界，就将会被淘汰。</p>
        </div>
        <div id="centuryHistory" class="phoneShow history">
          <div id="bgImg" class="parallax-bg"></div>
          <div class="swiper-container2 phoneShow">

            <div class="bg-line"></div>
            <div class="swiper-wrapper">
              <div class="swiper-slide" >
                <span class="point ani" style="bottom:58px" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s">
                  <span class="circle"></span>
                </span>
                <span class="year ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">1992</span>
                <span class="people ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">1 million</span>
                <p class="msg ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">一百万，只相当于青海西宁的总人口。</p>
                <img class="imgTitle ani" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s" src="../static/images/iconIndex.2.1.png">
              </div>
              <div class="swiper-slide" >
                <span class="point ani" style="bottom:86px" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s">
                  <span class="circle"></span>
                </span>
                <span class="year ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">2003</span>
                <span class="people ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">0.5 BILLION</span>
                <p class="msg ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">互联的设备11年间增长了49900%</p>
                <img class="imgTitle ani" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s" src="../static/images/iconIndex.2.2.png">
              </div>
              <div class="swiper-slide" >
                <span class="point ani" style="bottom:107px" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s">
                  <span class="circle"></span>
                </span>
                <span class="year ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">2009</span>
                <span class="people ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">LoT LNCEPTION</span>
                <p class="msg ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">CISCO认为万物互联的概念诞生于2009年</p>
                <img class="imgTitle ani" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s" src="../static/images/iconIndex.2.3.png">
              </div>
              <div class="swiper-slide" >
                <span class="point ani" style="bottom:126px" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s">
                  <span class="circle"></span>
                </span>
                <span class="year ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">2012</span>
                <span class="people ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">8.7 BILLION</span>
                <p class="msg ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">美国国家智能委员会就将ioT列为6项最具颠覆性的技术之一，直到2025年。</p>
                <img class="imgTitle ani" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s" src="../static/images/iconIndex.2.4.png">
              </div>
              <div class="swiper-slide" >
                <span class="point ani" style="bottom:135px" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s">
                  <span class="circle"></span>
                </span>
                <span class="year ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">2013</span>
                <span class="people ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">11.2 BILLION</span>
                <p class="msg ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">全球机器互联的数量，在2022年将达到180亿，其中大部分为消费电子和智能建筑设备。</p>
                <img class="imgTitle ani" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s" src="../static/images/iconIndex.2.5.png">
              </div>
              <div class="swiper-slide" >
                <span class="point ani" style="bottom:146px" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s">
                  <span class="circle"></span>
                </span>
                <span class="year ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">2014</span>
                <span class="people ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">14.4 BILLION</span>
                <p class="msg ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">联网设备的数量是地球人口的两倍</p>
                <img class="imgTitle ani" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s" src="../static/images/iconIndex.2.6.png">
              </div>
              <div class="swiper-slide" >
                <span class="point ani" style="bottom:163px" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s">
                  <span class="circle"></span>
                </span>
                <span class="year ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">2016</span>
                <span class="people ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">22.9 BILLION</span>
                <p class="msg ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">传感器流行——停车传感器、娱乐设备、智能电表都将通过宽带网络与其他设备连接。</p>
                <img class="imgTitle ani" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s" src="../static/images/iconIndex.2.7.png">
              </div>
              <div class="swiper-slide" >
                <span class="point ani" style="bottom:193px" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s">
                  <span class="circle"></span>
                </span>
                <span class="year ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">2020</span>
                <span class="people ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">50.1 BILLION</span>
                <p class="msg ani" swiper-animate-effect="bounceIn" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">届时地球上人均将持有6.6台联网设备</p>
                <img class="imgTitle ani" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s" src="../static/images/iconIndex.2.8.png">
              </div>
            </div>
          </div>
        </div> 
      </div>
      <br class='pcShow'>
      <div class="panel5">
        <div class="bg pcShow">
          <div class="txt_box">
            <h1 class="left">传统消费行为模式</h1>
            <h1 class="right">数字化客户生命周期</h1>
          </div>
          <div class="img_box">

            <div class="purchase_order">
              <h2 class="t1">知道</h2>
              <h2 class="t2">熟悉</h2>
              <h2 class="t3">考虑</h2>
              <h2 class="t4">购买</h2>
              <h2 class="t5">忠诚</h2>
            </div>
            
            <div   class='purchase_map' id='panel5_purchase_map'>
                <!--<svg xmlns="http://www.w3.org/2000/svg" version="1.1"  id="svg_map_line" width='100%' height='100%'>
                <g stroke-width='2' stroke='red' fill='transparent'>
                  <path class="connection" d='M355,27 C 238,49 189, 151, 228,185'></path>
                </g>
              </svg> -->
              <img src="../static/images/panel5_lines/com_index_5line1.png" alt="" class="bg1">
              <img src="../static/images/panel5_lines/com_index_5line2.png" alt="" class="bg2">
              <img src="../static/images/panel5_lines/com_index_5line3.png" alt="" class="bg3">
              <img src="../static/images/panel5_lines/com_index_5line4.png" alt="" class="bg4">
              <img src="../static/images/panel5_lines/com_index_5line5.png" alt="" class="bg5">
              <img src="../static/images/panel5_lines/com_index_5line6.png" alt="" class="bg6">
            </div>
            <span class="dashed_line"></span>
          </div>

        </div>
        <img class="phoneShow" src="../static/images/com_index_05fig.png" alt="">

      </div>
      <div class="panel6">
        <div class="title">
          <div class="box"></div>
          <h2>消费方式的转变</h2>
          <p>行为改变所带来的影响，及发展的战略</p>
          <span class="phoneSquare"></span>
        </div>
        <ul>
          <li>
            <h2>消费行为、习惯的变化：</h2>
            <p>移动互联网时代，用户在干什么？用户在看手机，在玩可穿戴设备。技术的驱动，带来用户行为趋势发生变化，进一步导致对产品、信息、服务的消费趋势发生变化。</p>
          </li>
          <li>
            <h2>消费中决策旅程：</h2>
            <p>用户的购买行为，从原来传统的漏斗形决策流程：知道、熟悉、考虑、购买、忠诚，变成了数字化客户生命周期中的复杂网状结构，增加了大量的<strong id='cnnt_node_toggle' @click.stop='mShow(2)'>接触点。</strong></p>
          </li>
          <li >
            <div class="phoneShow" id='panel6_connect_node_phone' @click.stop=''>
              <h2 class='phoneShow'>接触点：</h2>
              <p class='phoneShow'>在与用户沟通、面对面接触，进行物理或感官互动的过程中进行的有影响的行为。
              </p>
            </div>
            <div class="pcShow" id='connect_node'>

              <span >接触点：</span>
              <div>在与用户沟通、面对面接触，进行物理或感官互动的过程中进行的有影响的行为。</div>
            </div>
          </li>
        </ul>
      </div>
      <br class='pcShow'>
      <div class="panel7 pcShow">
        <h1>
          从你的品牌到你的竞争对手那里<br>只有手指<span>一个点击</span>的距离
        </h1>
        <p>以移动端来说，用户体验好意味着更多的客户和更长的访问时间</p>
        <div  class="box">
          <div class="leftbox">
            <div>
              <img src="../static/images/good.png"/>
              <span>67%</span>
            </div>

            <h2>用户体验好=更愿意购买</h2>
            <p>用户体验好的移动应用增加了67%的购买意愿。</p>
          </div>
          <div class="rightbox">
            <div>
              <img src="../static/images/bad.png"/>
              <span>61%</span>
            </div>

            <h2>用户体验差=倾向于离开</h2>
            <p>如果用户不能在移动应用上方便地看到想要的内容，61%的情况会切换到你的竞争对手那里去。</p>
          </div>
        </div>
      </div>
      <div class="panel7 phoneShow">
        <!-- <div class="mengban2"></div> -->
        <div class="bg">
          <div class="centerPart">
            <img class="square" src="../static/images/square5.png">
          </div>
          <div class="center">
            <h1>
              从你的品牌到你的竞争对手那里<br />只有手指一个点击的距离
              <span class="phoneShow"></span>
            </h1>
            <p class="phoneShow">以移动端来说，用户体验好意味着更多的客户和更长的访问时间</p>
            <div class="box">
              <div class="swiper-container6">
                <div class="swiper-wrapper">
                  <div  class="leftbox swiper-slide">
                    <div>
                      <img src="../static/images/good.png"/>
                      <span>67%</span>
                    </div>
                    <img class="textPic" src="../static/images/text_FRIENDLY.png">
                    <p>用户体验好=更愿意购买</p>
                    <p>用户体验好的移动应用增加了67%的购买意愿。</p>
                  </div>
                  <!-- flex="dir:top main:top cross:center" -->
                  <div  class="rightbox swiper-slide">
                    <div>
                      <img src="../static/images/bad.png"/>
                      <span>61%</span>
                    </div>
                    <img class="textPic2" src="../static/images/text_UNFRIENDLY.png">
                    <p>用户体验差=倾向于离开</p>
                    <p>如果用户不能在移动应用上方便地看到想要的内容，61%的情况会切换到你的竞争对手那里去。</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel8">
        <div  class='txt_box'>
          <h1>移动互联网为何厉害？<br class='pcShow'>
          </h1>
          <ul class="phoneShow">
            <li><p>通过手机更容易影响用户。</p></li>
            <li><p>实现“消费者赋权”，真正把权力归还消费者。</p></li>
            <li><p>彻底地打通线上的虚拟世界与线下的真实世界。</p></li>
            <li><p>对于用户的感知与洞察更强，甚至比你更懂你的用户。</p></li>
            <li><p>可以免费地实现同样的业务，甚至体验比你做得更好。</p></li>
          </ul>
          <div class='main pcShow'>
            <p>通过手机更容易影响用户。</p>
            <p>实现“消费者赋权”，真正把权力归还消费者。</p>
            <p>彻底地打通线上的虚拟世界与线下的真实世界。</p>
            <p>对于用户的感知与洞察更强，甚至比你更懂你的用户。</p>
            <p>可以免费地实现同样的业务，甚至体验比你做得更好。</p>
          </div>
          <div class='right pcShow'>
            <p>
            </p>
          </div>
        </div>
      </div>
      <br class='pcShow'>
      <div class="panel9">
        <div class="bg">
          <h1>品牌数字化</h1>
          <p class="msg">在移动互联网时代，帮助品牌切换赛道到数字世界，基于新经济规则做生意</p>
          <div class="pcShow">
            <ul flex="dir:left main:center">
              <li flex="dir:top main:center cross:center">
                <div class="box">
                  <img src="../static/images/icon_point1.png">
                  <p>通过打造以移动互联网为主的数字化平台，将品牌的生意运行于数字化的世界。</p>
                  <p>基于数字化平台，通过优秀的数字化用户体验，连接用户，营销和运营的旅程。</p>
                </div>
                <h2>品牌数字化的定义</h2>
                <img src="../static/images/icon_left.png"/>
              </li>
              <li flex="dir:top main:center cross:center">
                <div class="box">
                  <img src="../static/images/icon_point2.png">
                  <p>企业需要好的解决方案，能够提供便捷的方式，让各个利益相关者（员工、合作伙伴、和客户）</p>
                  <p>通过所有相关的渠道（网站，移动端，App，社交网络，物联网等等）进行参与互动和协作。</p>
                </div>
                <h2>价值之业务管理层面</h2>
                <img src="../static/images/icon_mid.png"/>
              </li>
              <li flex="dir:top main:center cross:center">
                <div class="box">
                  <img src="../static/images/icon_point3.png">
                  <p>实际上，旧的工作、管理、做生意的方式在强大的数字化系统的法则面前不堪一击。</p>
                  <p>因为数字化平台可以提供源源不断的动力，让价值创造的活动更快、更便宜、更海量、更优质。</p>
                </div>
                <h2>价值之效果层面</h2>
                <img src="../static/images/icon_right.png"/>
              </ul>
            </div>
            <div class="swiper-container1 phoneShow">
              <div class="swiper-wrapper">
                <div class="swiper-slide item" flex="dir:top main:center cross:center">
                 <div class="box box1">
                  <img src="../static/images/icon_point1.png">
                  <p>通过打造以移动互联网为主的数字化平台，将品牌的生意运行于数字化的世界。</p>
                  <p>基于数字化平台，通过优秀的数字化用户体验，连接用户，营销和运营的旅程。</p>
                </div>
                <h2>品牌数字化的定义</h2>
                <img src="../static/images/icon_left.png"/>
              </div>
              <div class="swiper-slide item" flex="dir:top main:center cross:center">
                <div class="box box2">
                  <img src="../static/images/icon_point2.png">
                  <p>企业需要好的解决方案，能够提供便捷的方式，让各个利益相关者（员工、合作伙伴、和客户）</p>
                  <p>通过所有相关的渠道(网站,移动端,App,社交网络,物联网等等)进行参与互动和协作。</p>
                </div>
                <h2>价值之业务管理层面</h2>
                <img src="../static/images/icon_mid.png"/>
              </div>
              <div class="swiper-slide item" flex="dir:top main:center cross:center">
                <div class="box box3">
                  <img src="../static/images/icon_point3.png">
                  <p>实际上，旧的工作、管理、做生意的方式在强大的数字化系统的法则面前不堪一击。</p>
                  <p>因为数字化平台可以提供源源不断的动力，让价值创造的活动更快、更便宜、更海量、更优质。</p>
                </div>
                <h2>价值之效果层面</h2>
                <img src="../static/images/icon_right.png"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-connect></app-connect>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
  import bus from './bus.js'
  import Nav from './Navigation.vue'
  import Connect from './Connect.vue'
  import Footer from './Footer.vue'


  require('../static/libs/swiper.min.css');
  require('../static/libs/animate.css');
  require('../static/libs/animate.min.css');
  require('../static/libs/swiper.min.js');
// import swiperAni from '../static/libs/swiper.animate.min.js';
var sa = require( '../static/libs/swiper.animate.min.js');
export default {
  data () {
    return {
        // note: changing this line won't causes changes
        // with hot-reload because the reloaded component
        // preserves its current state and we are modifying
        // its initial state.
        msg: 'center',
      }
    },
    ready:function() {
      { //panel4 折线图 start 
        var SVN='http://www.w3.org/2000/svg'
        var iRatio=2;
        var outWidth=iRatio*930,outHeight=iRatio*502,iSpacing=1.05*iRatio;
        var iDashWidth=iRatio*2,iYearSize=iRatio*12,iTextSize=iRatio*10,iNodeR=iRatio*3,iTextWeight=0.15*iRatio;
        var sDashColor="#949494",sPropColor='#2d2d2d',sTextColor='#444',sNodeColor='#2d2d2d',sDashStyle=5*iRatio+','+5*iRatio;

        var e_line_chart=document.getElementById('line_chart');
        var e_svg=$('#svg_chart');
        var i,sPolyPoints='';
        var aChartDetails=[
        {
          'id':"i1990",
          'year':'1992',
          'prop':'1million',
          'text1':'一百万，只相当于青海西宁的',
          'text2':'总人口',
          'nodeX':234*iRatio,
          'nodeY':495*iRatio,
          'dashTopX':234*iRatio,
          'dashTopY':443*iRatio,
          'dashLeftX':193*iRatio,
          'dashLeftY':443*iRatio,
          'picX':145*iRatio,
          'picY':418*iRatio,
          'txtX':139*iRatio,
          'txtY':428*iRatio
        },
        {
          'id':"i2003",
          'year':'2003',
          'prop':'0.5 BILLION',
          'text1':'互联网的设备11年间增长了49900%',
          'text2':'',
          'nodeX':(386)*iRatio,
          'nodeY':(486)*iRatio,
          'dashTopX':(386)*iRatio,
          'dashTopY':(366)*iRatio,
          'dashLeftX':(86+162+48)*iRatio,
          'dashLeftY':(366)*iRatio,
          'picX':(248)*iRatio,
          'picY':(344)*iRatio,
          'txtX':(-3+248)*iRatio,
          'txtY':(-3+351+12)*iRatio
        },
        {
          'id':"i2009",
          'year':'2009',
          'prop':'LoT LNCEPTION',
          'text1':'CISCO认为万物互联的概念将诞生于',
          'text2':'2009年',
          'nodeX':(586)*iRatio,
          'nodeY':(402)*iRatio,
          'dashTopX':(586)*iRatio,
          'dashTopY':(303)*iRatio,
          'dashLeftX':(199+198+48)*iRatio,
          'dashLeftY':(303)*iRatio,
          'picX':(397)*iRatio,
          'picY':(278)*iRatio,
          'txtX':(-3+397)*iRatio,
          'txtY':(-3+271+24)*iRatio
        },
        {
          'id':"i2012",
          'year':'2012',
          'prop':'8.7 BILLION',
          'text1':'美国国家智能委员会就将ioT列为6项最具',
          'text2':'颠覆性的技术之一，直到2025年。',
          'nodeX':(688)*iRatio,
          'nodeY':(315)*iRatio,
          'dashTopX':(688)*iRatio,
          'dashTopY':(238)*iRatio,
          'dashLeftX':(153+196+48)*iRatio,
          'dashLeftY':(238)*iRatio,
          'picX':(349)*iRatio,
          'picY':(214)*iRatio,
          'txtX':(-3+349)*iRatio,
          'txtY':(-3+218+12)*iRatio
        },
        {
          'id':"i2013",
          'year':'2013',
          'prop':'11.2 BILLION',
          'text1':'全球机器互联的数量，在2022年将达到180亿，其中大部分',
          'text2':'为消费电子和智能建筑设备',
          'nodeX':(736)*iRatio,
          'nodeY':(296)*iRatio,
          'dashTopX':(736)*iRatio,
          'dashTopY':(191)*iRatio,
          'dashLeftX':(568+48)*iRatio,
          'dashLeftY':(191)*iRatio,
          'picX':(568)*iRatio,
          'picY':(167)*iRatio,
          'txtX':(-3+568)*iRatio,
          'txtY':(-3+169+12)*iRatio
        },
        {
          'id':"i2014",
          'year':'2014',
          'prop':'14.4 BILLION',
          'text1':'联网设备的数量是地球人的两倍',
          'text2':'',
          'nodeX':(795)*iRatio,
          'nodeY':(238)*iRatio,
          'dashTopX':(795)*iRatio,
          'dashTopY':(133)*iRatio,
          'dashLeftX':(343+149+48)*iRatio,
          'dashLeftY':(133)*iRatio,
          'picX':(343+149)*iRatio,
          'picY':(110)*iRatio,
          'txtX':(-3+343+149)*iRatio,
          'txtY':(-3+117+12)*iRatio
        },
        {
          'id':"i2016",
          'year':'2016',
          'prop':'22.9 BILLION',
          'text1':'传感器流行——停车传感器、娱乐设备、智能电表',
          'text2':'都通过宽带网络与其他设备连接。',
          'nodeX':(870)*iRatio,
          'nodeY':(153)*iRatio,
          'dashTopX':(870)*iRatio,
          'dashTopY':(82)*iRatio,
          'dashLeftX':(499+233+48)*iRatio,
          'dashLeftY':(82)*iRatio,
          'picX':(499+233)*iRatio,
          'picY':(56)*iRatio,
          'txtX':(-3+499+233)*iRatio,
          'txtY':(56+12)*iRatio
        },
        {
          'id':"i2020",
          'year':'2020',
          'prop':'50.1 BILLION',
          'text1':'届时地球上人均将持有6.6台联网设备',
          'text2':'',
          'nodeX':(926)*iRatio,
          'nodeY':(101)*iRatio,
          'dashTopX':(926)*iRatio,
          'dashTopY':(20)*iRatio,
          'dashLeftX':(461+178+48)*iRatio,
          'dashLeftY':(20)*iRatio,
          'picX':(643)*iRatio,
          'picY':(0)*iRatio,
          'txtX':(-3+643)*iRatio,
          'txtY':(-3+5+12)*iRatio
        }
        ]

        e_line_chart.style.width=outWidth+'px'
        e_line_chart.style.height=outHeight+'px'
        e_line_chart.style.backgroundColor='#fff'
        e_svg.attr('width',outWidth)
        e_svg.attr('height',outHeight)

        for (i=0;i<aChartDetails.length;i++){ //creat all 
          sPolyPoints=sPolyPoints+aChartDetails[i].nodeX+','+aChartDetails[i].nodeY+' '
        }

        // console.log(sPolyPoints)
        var eChartLine=document.createElementNS(SVN,'polyline')
        $(eChartLine).attr({
          'points':sPolyPoints,
          'fill':'none',
          'stroke-width':2*iRatio,
          'stroke':sPropColor
        })
        e_svg.append(eChartLine)
        for (i=0;i<aChartDetails.length;i++){ //creat all 
          fDrawNodeDetails(aChartDetails[i])
        }      
        /*
        *
        */
        function fDrawNodeDetails(AoNodeDetails){  //创建单个点的图像和文字 *args:(点的信息对象)
          var eNewG=document.createElementNS(SVN,'g')
          var eNode=document.createElementNS(SVN,'circle')
          var eYear=document.createElementNS(SVN,'text')
          var eProp=document.createElementNS(SVN,'text')
          var eText1=document.createElementNS(SVN,'text')
          var eText2=document.createElementNS(SVN,'text')
          var eDash1=document.createElementNS(SVN,'line')
          var eDash2=document.createElementNS(SVN,'line')
          $(eNode).attr({
            'cx':AoNodeDetails.nodeX,
            'cy':AoNodeDetails.nodeY,
            'r':iNodeR,
            'fill':sNodeColor
          })
          $(eDash1).attr({
            'x1':AoNodeDetails.nodeX,
            'y1':AoNodeDetails.nodeY - iNodeR,
            'x2':AoNodeDetails.dashTopX,
            'y2':AoNodeDetails.dashTopY,
            'stroke-width':iDashWidth,
            'stroke':sDashColor,
            'stroke-dasharray':sDashStyle
          })
          $(eDash2).attr({
            'x2':AoNodeDetails.dashLeftX,
            'y2':AoNodeDetails.dashLeftY,
            'x1':AoNodeDetails.dashTopX,
            'y1':AoNodeDetails.dashTopY,
            'stroke-width':iDashWidth,
            'stroke':sDashColor,
            'stroke-dasharray':sDashStyle
          })
          eYear.textContent=AoNodeDetails.year
          $(eYear).attr({
            'x':AoNodeDetails.txtX,
            'y':AoNodeDetails.txtY,
            'text-anchor':'end',
            'style':'font-size:'+iYearSize+'px;letter-spacing:'+iSpacing+'px',
            'stroke':sTextColor,
            'fill':sTextColor
          })
          eProp.textContent=AoNodeDetails.prop
          $(eProp).attr({
            'x':AoNodeDetails.txtX,
            'y':AoNodeDetails.txtY+iYearSize*1.1,
            'text-anchor':'end',
            'style':'font-size:'+iYearSize+'px;letter-spacing:'+iSpacing+'px',
            'stroke':sPropColor,
            'fill':sPropColor,
            'stroke-width':1.25*iRatio
          })
          eText1.textContent=AoNodeDetails.text1
          $(eText1).attr({
            'x':AoNodeDetails.txtX,
            'y':AoNodeDetails.txtY+iYearSize*1.1*2,
            'text-anchor':'end',
            'style':'font-size:'+iTextSize+'px;letter-spacing:'+iSpacing+'px',
            'stroke':sTextColor,
            'stroke-width':iTextWeight,
            'fill':sTextColor
          })
          eText2.textContent=AoNodeDetails.text2
          var iSpacing2=iSpacing*1.5;
          $(eText2).attr({
            'x':AoNodeDetails.txtX,
            'y':AoNodeDetails.txtY + iYearSize*1.1*2 + iTextSize*1.1,
            'text-anchor':'end',
            'style':'font-size:'+iTextSize+'px;letter-spacing:'+iSpacing2+'px',
            'stroke':sTextColor,
            'stroke-width':iTextWeight,
            'fill':sTextColor
          })
          // console.log($('img.'+AoNodeDetails.id))
          $('img.'+AoNodeDetails.id).css({
            'left':AoNodeDetails.picX,
            'top':AoNodeDetails.picY,
            'width':48*iRatio
          })
          $(eNewG).append(eNode,eDash1,eDash2,eYear,eProp,eText1,eText2)
          $(eNewG).attr('id',AoNodeDetails.id)
          e_svg.append(eNewG)
        }
      }// panel4 折线图 end 
      { // function enter animation start

        var e_icon_panel4=document.getElementsByClassName('panel4_icon')
        var e_g_panel4=document.getElementById('svg_chart').getElementsByTagName('g')
        var oAnimate=[],oAnimate_icon=[]
        oAnimate[0]= new fEnterIn(e_g_panel4[0])
        oAnimate[0].trigger(0.95).otherCss({'opacity':0}).duration('0.6s')
        oAnimate_icon[0]= oAnimate[0].followAnimation(e_icon_panel4[0])
        oAnimate_icon[0].delay('-0.6s')
        var i,l=e_icon_panel4.length;
        //遍历！ .delay('-0.2s')
        for(i=1;i<l;i++){
          oAnimate[i]=oAnimate[i-1].followAnimation(e_g_panel4[i]).delay('-0.3s')
          oAnimate_icon[i]=oAnimate_icon[i-1].followAnimation(e_icon_panel4[i]).delay('-0.3s')

        }
        // oAnimate1990.otherCss({'opacity':0}).followAnimation('#i2003').followAnimation('#i2009').followAnimation('#i2012').followAnimation('#i2013').followAnimation('#i2014').followAnimation('#i2016').followAnimation('#i2020')
        // var oAnimate1990_icon=oAnimate1990.followAnimation(e_icon_panel4[0])
        // oAnimate1990_icon.delay('-0.5s')
        // oAnimate1990_icon.followAnimation(e_icon_panel4[1]).followAnimation(e_icon_panel4[2]).followAnimation(e_icon_panel4[3]).followAnimation(e_icon_panel4[4]).followAnimation(e_icon_panel4[5]).followAnimation(e_icon_panel4[6]).followAnimation(e_icon_panel4[7])
      } // function enter animation end
      // {// 路径动画  暂弃用
        //   var test_path=document.getElementsByClassName('connection')[0]
        //   var svg_path=document.getElementById('svg_map_line')
        //   console.log('test_path',test_path.getTotalLength())
        //   var test_path_length=test_path.getTotalLength()
        //   test_path.setAttribute("stroke-dasharray",test_path_length)
        //   test_path.setAttribute("stroke-dashoffset",test_path_length)
        //   svg_path.onmouseover=function(){
        //     test_path.setAttribute("stroke-dashoffset",0)
        //     this.onmouseout =function(){
        //       console.log('out')
        //       test_path.setAttribute("stroke-dashoffset",test_path_length)
        //     }
        //   }
      // }
      {//路径动画  panel5
        var e_panel5_purchase_map=document.getElementById('panel5_purchase_map')
        var e_line_panel5=e_panel5_purchase_map.getElementsByTagName('img')
        var i,l=e_line_panel5.length,aAnimationLinePanel5=[]
        aAnimationLinePanel5[0]= new fEnterIn(e_line_panel5[0])
        aAnimationLinePanel5[0].trigger(0.9).otherCss({'opacity':0}).duration('0.5s')
        console.log('e_line_panel5',e_line_panel5[0],aAnimationLinePanel5[0])
        for(i=1;i<l;i++){
          aAnimationLinePanel5[i]=aAnimationLinePanel5[i-1].followAnimation(e_line_panel5[i])
        }
      }
        //swiper
        fSetRem();
        function fSetRem(){
          var widthWin=window.innerWidth;
          var remDefault=document.documentElement.style.fontSize = window.innerWidth/3.75 + 'px';
        // console.log("resizing",widthWin,remDefault)
      }
      window.onresize=function(){
        fSetRem();
      }
      var bgImg = $("#bgImg");
      var e_span_exp = $("#span_exp");
      var e_span_dig_exp = $("#span_dig_exp");
      var e_cnnt_node_toggle = $("#cnnt_node_toggle");

      var wd = window.innerWidth;
      var pyi = (wd - 320)/2;
      console.log();
      var initShift = -9;
      var mapLength = 11;
      var words = [(initShift - pyi)+'px',(initShift - 11*mapLength - pyi)+'px',(initShift - 17*mapLength - pyi)+'px',(initShift - 20*mapLength - pyi)+'px',(initShift - 21*mapLength - pyi)+'px',(initShift - 22*mapLength - pyi)+'px',(initShift - 24*mapLength - pyi)+'px',(initShift - 28*mapLength - pyi)+'px',0];
      var transtion = [0,-wd,-wd*2,-wd*3,-wd*4,-wd*5,-wd*6,-wd*7];
      console.log(words.toString());
      var swiper = new Swiper('.swiper-container', {
        pagination: '.swiper-pagination',
        paginationClickable: false,
        loop : true,
        autoplay: 1500
      });
      var swiper2 = new Swiper('.swiper-container1', {
        slidesPerView: 'auto',
        centeredSlides: true,
        loop : true,
        autoplay: 1500
      });
      bgImg.css("transform","translate3d(" + words[0] + ", 0px, 0px)");
      var swiper3 = new Swiper('.swiper-container2', {
        effect : 'fade',
        fade: {
          crossFade: true,
        },
        parallax: true,
        lazyLoading : true,
        speed: 600,
        autoplay: 2000,
        autoplayStopOnLast : true,
        onInit: function(swiper){ //Swiper2.x的初始化是onFirstInit
          console.log(sa);
          sa.swiperAnimateCache(swiper); //隐藏动画元素 
          sa.swiperAnimate(swiper); //初始化完成开始动画
        }, 
        onTransitionStart: function(swiper){ 
          console.log("当前index: " + swiper.activeIndex);
          console.log("start: " + swiper.translate);
          console.log("start: " + transtion[swiper.activeIndex]);
          console.log("start: " + transtion[0]);
          if(swiper.translate < transtion[swiper.activeIndex] && swiper.translate > transtion[7]) {
            console.log("向左走");
            bgImg.css("transform","translate3d(" + words[swiper.activeIndex] + ", 0px, 0px)");
            bgImg.css("transition","transform 600ms");
          }
          else if(swiper.translate > transtion[swiper.activeIndex] && swiper.translate <= transtion[0]) {
            console.log("向右走");
            bgImg.css("transform","translate3d(" + words[swiper.activeIndex] + ", 0px, 0px)");
            bgImg.css("transition","transform 600ms");
          }           
        },
        onTransitionEnd: function(swiper){ 
          // console.log("hello");
          // console.log("end: "+swiper.translate);
          sa.swiperAnimate(swiper); //每个slide切换结束时也运行当前slide动画
        }
      });
      var swiper4 = new Swiper('.swiper-container3', {
        pagination: '.swiper-pagination',
        paginationClickable: false,
        loop : true,
        autoplay: 1500
      });
      var swiper5 = new Swiper('.swiper-container5', {
        slidesPerView: 'auto',
        centeredSlides: true,
        autoplayDisableOnInteraction:false,
        loop : true,
        autoplay: 3000
      });
      var swiper6 = new Swiper('.swiper-container6', {
        slidesPerView: 'auto',
        centeredSlides: true,
        autoplayDisableOnInteraction:false,
        loop : true,
        autoplay: 3000
      });
      var swiper7 = new Swiper('.swiper-container7', {
        slidesPerView: 'auto',
        centeredSlides: true,
        autoplayDisableOnInteraction:false,
        autoplay: 3000,
        loop : true
      });
      // console.log('swiper5:',swiper5)
      // onmouseover="fHover(1,swiper5)"
      function fHover(index){
        // console.log($('.swiper-container5'))
        // $('.swiper-container5').css('color',"#4494fb")
        var iActiveIndex;
        if(index==0){
          iActiveIndex=swiper5.activeIndex-swiper5.activeIndex%2
        }
        else if(index==1){
          iActiveIndex=swiper5.activeIndex-swiper5.activeIndex%2+1;
        }
        swiper5.slideTo(iActiveIndex,500,true);
      }     
      // console.log('e_span_exp',e_span_exp)
      e_span_exp.hover(function(){
        fHover(0)
      },function(){
        // $('.swiper-container5').css('color',"#fff")
      });
      e_span_dig_exp.hover(function(){
        fHover(1)
      },function(){
        // $('.swiper-container5').css('color',"#fff")
      })
      var e_connect_node = $("#connect_node");

      e_cnnt_node_toggle.hover(function(){
        console.log('hover')
        e_connect_node.css({'visibility':'visible','display':'block'})
        $('#panel6_connect_node_phone').css({'visibility':'visible','display':'block'})
      },function(){
        console.log('out')
        e_connect_node.css({'visibility':'hidden','display':'none'})
        $('#panel6_connect_node_phone').css({'visibility':'hidden','display':'none'})
      })

      document.body.onclick=function(){
        console.log('click body' )
        $('#panel2_exp_phone').css('display','none')
        $('#panel2_dig_exp_phone').css('display','none')
        $('#panel6_connect_node_phone').css('display','none')

      }
    },
    components:{
      'app-nav':Nav,
      'app-connect':Connect,
      'app-footer':Footer
    },
    computed: {
      scroll: function() {
        //window.scroll
        //panel5 animation-delay
        var wh = window.innerHeight;
        var pos1 = $($(".panel5")[0]);
        if(pos1.offset() != null) {
          if(bus.scroll > pos1.offset().top - wh/2 ) {  //(wh - parseInt(pos1.css("height")))/2 
            $(document.getElementsByClassName("purchase_order")[0]).addClass("active");
          }
        }


        //panel8 animation
        var pos2 = $($(".panel8")[0]);
        if(pos2.offset() != null) {
          if(bus.scroll > pos2.offset().top - wh/2 ) { //(wh - parseInt(pos2.css("height")))/2
            $(".panel8 div p").addClass("active");
          }
        }

        return bus.scroll;
      },
    },
    methods:{
      mShow(index){
        if(index===0){
          this.mHideAll();
          $('#panel2_exp_phone').css('display','block')
        }
        else if(index===1){
          this.mHideAll();
          $('#panel2_dig_exp_phone').css('display','block')
        }
        else if(index===2){
          this.mHideAll();
          $('#panel6_connect_node_phone').css('display','block')
        }
        console.log('click strong')

      },
      mHideAll(){
        $('#panel6_connect_node_phone').css('display','none')
        $('#panel2_exp_phone').css('display','none')
        $('#panel2_dig_exp_phone').css('display','none')
      }
    }
  }

</script>

<style lang="sass" scoped>
  /* common */
  * {
    -webkit-flex-wrap:wrap;
    flex-wrap:wrap;
  }
  /*animate*/
  .panel5 .connection{
    transition: 1s;
  }
  .panel5 .bg .img_box .purchase_map img{
    transition: 1s;
  }
  @keyframes show1 {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0px);
    }
  }
  @keyframes show2 {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0px);
    }
  }
  @keyframes show4 {
    from {
      opacity: 1;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0px);
    }
  }
  @keyframes show5 {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes show6 {
    from {
      opacity: 0;
      transform: translateY(10px);
      padding-top: 10px;
    }
    to {
      opacity: 1;
      transform: translateY(0px);
    }
  }

  @mixin global($percent:1) {
    .panel4_icon{
      position: absolute;
    }
    #line_chart{
      position: relative;
      -webkit-transform: scale(0.5) translate(-50%,-50%);
      -ms-transform: scale(0.5) translate(-50%,-50%);
      -o-transform: scale(0.5) translate(-50%,-50%);
      transform: scale(0.5) translate(-50%,-50%);
    }
    .container {
      text-align: center;
      overflow: hidden;
    }
    p {
      line-height: 18px*$percent;
    }
    /*等待更好的方法*/
    

    .panel1 {
      overflow: hidden;
      .bg {
        background: url(../static/images/com_index_1bg.jpg) no-repeat center center;
        background-size: cover;
        /*height:666px*$percent;*/
        height:100vh;
        width: 1920px*$percent;
        text-align: center;
        position: relative;
        h1 {
          position: relative;
          font-size: 30px*$percent;
          top:calc(40%);
          color:#F1F6FF;
          text-shadow:3px 4px 23px rgba(255,255,255,0.7),
          -3px -4px 20px rgba(255,255,255,0.7);
          overflow: visible;
          font-weight: normal;
          letter-spacing: 4px*$percent;
          margin-bottom: 10px*$percent;
          opacity: 0;
          animation: show2 0.5s;
          -webkit-animation-fill-mode: forwards;
          -o-animation-fill-mode: forwards;
          animation-fill-mode: forwards;
        }
        h2 {
          position: relative;
          top:calc(40%);
          font-size: 40px*$percent;
          color:#F1F6FF;
          opacity: 0;
          text-shadow:3px 4px 23px rgba(255,255,255,0.7),
          -3px -4px 20px rgba(255,255,255,0.7);
          overflow: visible;
          font-weight: normal;
          letter-spacing: 6px*$percent;
          line-height: 60px*$percent;
          animation: show1 0.5s;
          animation-delay: 0.5s;
          animation-fill-mode: forwards;
          &:nth-child(3) {
            animation: show1 0.5s;
            animation-delay: 1s;
            animation-fill-mode: forwards;
          };
        }
        
        .note {
          font-size: 12px*$percent;
          line-height: 16px;
          -webkit-transform: scale($percent);
          position: absolute;
          bottom:18px*$percent;
          left:0;
          right: 0;
          p {
            position: relative;
            padding:5px*$percent 0;
            text-align: center;
            color:white;
            opacity: 0;
            animation: show1 0.5s;
            animation-delay: 1.5s;
            animation-fill-mode: forwards;
            &:nth-child(2) {
              padding-bottom:10px*$percent;
              animation: show1 0.5s;
              animation-delay: 2s;
              animation-fill-mode: forwards;
            };
          }
          
          .arrow{
            position: relative;
            margin: 0 auto;
            margin-top: 10px*$percent;
            font-size: 16px*$percent;
            color: #fff;
            width: 20px*$percent;height: 20px*$percent;
            vertical-align: middle;
            font-family: '黑体';
            opacity:0;
            animation: show4 0.6s infinite;
            animation-direction:alternate;
            animation-timing-function:linear;
            animation-delay: 2.5s;
            span{
              font-family: '黑体';
              /*height: 20px*$percent;*/
              position: relative;
              bottom: 2px*$percent;
              font-size: 12px*$percent;
              line-height: 20px*$percent;
              vertical-align: middle;

            }
          }
        }
      }
    }

    .panel3 {
      .bg {
        width:1920px*$percent;
        height:603px*$percent; 
        background: url(../static/images/com_index_3bg.jpg) no-repeat center center;
        background-size: cover;
        position: relative;
        .leftbox {
          position: relative;
          width:349px*$percent;
          margin-top: -150px*$percent;
          overflow: visible;
          h2 {
            font-size: 24px*$percent;
            color:rgb(58,247,178);
            line-height: 66px*$percent;
            letter-spacing: 3px*$percent;
            margin-bottom: 5px*$percent;
            position: relative;
            font-weight: 400;
            z-index: 1;
            text-align: left;
            &:after {
              position:absolute;
              top:0;
              right: 124px*$percent;
              width:137px*$percent;
              height: 50px*$percent;
              content: ' ';
              border:8px*$percent solid #52626f;
              z-index: -1;
            };
          }
          p {
            position: relative;
            font-size: 16px*$percent;
            -webkit-transform: scale($percent);
            color:white;
            padding-bottom: 20px*$percent;
            letter-spacing: 2px*$percent;
            line-height: normal;
            text-align: left;
          }
        }
        .rightbox {
          &.phoneShow {
            display: none;
          }
          width: 722px*$percent;
          height: 483px*$percent;
          margin-left: 50px*$percent;
          ul {
            .item {
              position: relative;
              float:left;
              width:50%;
              height:241px*$percent;
              text-align: left;
              &:nth-child(1) .box{
                background: url(../static/images/icon1.png) no-repeat left top;
                background-size: 30px*$percent 29px*$percent;
                margin-top: 30px*$percent;
              }
              &:nth-child(2) .box{
                background: url(../static/images/icon2.png) no-repeat left top;
                background-size: 34px*$percent 29px*$percent;
                margin-top: 30px*$percent;
              }
              &:nth-child(3) .box{
                background: url(../static/images/icon3.png) no-repeat left top;
                background-size: 32px*$percent 29px*$percent;
                margin: 30px*$percent 0;
              }
              &:nth-child(4) .box{
                background: url(../static/images/icon4.png) no-repeat left top;
                background-size: 32px*$percent 22px*$percent;
                margin: 30px*$percent 0;
              }
              .box {
                /*float:left;*/
                width:215px*$percent;
                padding-left: 50px*$percent;
                p {
                  font-size: 16px*$percent;
                  margin-top: 14px*$percent;
                  margin-bottom: 10px*$percent;
                  line-height: 20px*$percent;
                  color:white;
                }
                & h3 {
                  position: relative;
                  font-size: 16px*$percent;
                  color:white;
                  padding-bottom: 10px*$percent;
                  &:after {
                    position: absolute;
                    bottom: 0;
                    left: 1px*$percent;
                    width: 27px*$percent;
                    content: ' ';
                    height: 1px*$percent;
                    background-color: #4494FB;
                    -webkit-transform: scaleY(.5);
                  }
                }
                ul {
                  list-style-type:disc;
                  list-style-position:inside;
                  color: white;
                  li {
                    width: 100%;
                    font-weight: 700;
                    font-size: 12px*$percent;
                    -webkit-transform: translate(($percent - 1)/2*100%,($percent - 1)/2*100%) scale($percent);
                    line-height: 16px;
                    letter-spacing: 1px*$percent;
                  }
                }
              }
            }
          }
        }
      }
    }

    .panel5 {
      height:810px*$percent;
      overflow: hidden;
      text-align: center;
      .bg {
        display: inline-block;
        margin:0 -50%;
        width:1920px*$percent;
        height:810px*$percent; 
        background: #fff ;
        background-size: 1097px*$percent 550px*$percent;
        background-position: 412px*$percent 20px*$percent;
        position: relative;
        .txt_box{
          width: 689px*$percent;
          height: 42px*$percent;
          position: absolute;
          top:128px*$percent;
          left: 485px*$percent;
          border-bottom: 2px dashed #104248;
          h1 {
            text-align: left;
            width: 300px*$percent;
            /*display: inline-block;*/
            font-size: 24px*$percent;
            line-height: 1;
            color:#12294E;
            position: absolute;
            /*top:128px*$percent;*/
            /*left: 448px*$percent;*/
            &:last-child {
              left:468px*$percent;
            };
          }
        }
        .img_box{
          width: 941px*$percent;
          height: 373px*$percent;
          top: 260px*$percent;
          position: absolute;
          left: 0;right: 0;
          margin:0 auto;
          border-bottom: 2px dashed #104248;
          .purchase_order{
            display: inline;
            position: absolute;
            left: 0;
            top: 0;
            width: 261px*$percent;
            height: 328px*$percent;
            background: url("../static/images/com_index_5fig1.png") no-repeat center center;
            background-size: cover;
            h2{
              font-size: 12px*$percent;
              color: #fff;
              position:relative;
              line-height: 0;
              font-weight: normal;
              text-align: center;
              padding-right: 8px*$percent;
              opacity: 0;
            }
            &.active {
              .t1{
                animation: show5 0.6s;
                animation-direction:alternate;
                animation-timing-function: linear;
                animation-delay: 0;
                animation-fill-mode: forwards;
              }
              .t2{
                animation: show5 0.6s;
                animation-direction:alternate;
                animation-delay: 0.5s;
                animation-timing-function: linear;
                animation-fill-mode: forwards;
              }
              .t3{
                animation: show5 0.6s;
                animation-delay: 1s;
                animation-direction:alternate;
                animation-timing-function: linear;
                animation-fill-mode: forwards;
              }
              .t4{
                animation: show5 0.6s;
                animation-direction:alternate;
                animation-delay: 1.5s;
                animation-timing-function: linear;
                animation-fill-mode: forwards;
              }
              .t5{
                animation: show5 0.6s;
                animation-delay: 2s;
                animation-direction:alternate;
                animation-timing-function: linear;
                animation-fill-mode: forwards;
              }
            }
            h2.t1{
              top: (66px + 5px + 12px * 0)*$percent;
            }
            .t2{
              top:(102px + 5px + 12px * 1)*$percent;
            }
            .t3{
              top:(138px + 5px + 12px * 2)*$percent;
            }
            .t4{
              top:(174px + 5px + 12px * 3)*$percent;
            }
            .t5{
              top:(210px + 5px + 12px * 4)*$percent;
            }

          }
          .purchase_map{
            position: absolute;
            width: 478px*$percent;
            height: 339px*$percent;
            right: 0;
            top: 0;
            background: url(../static/images/com_index_5fig2.png) no-repeat center center;
            background-size: cover;
            img{
              position: absolute;
            }
            .bg1{
              width: 405px*$percent;
              left: 38px*$percent;
              top: 30px*$percent;
            }
            .bg2{
              width: 129px*$percent;
              left: 226px*$percent;
              top: 25px*$percent;
            }
            .bg3{
              width: 18px*$percent;
              left: 289px*$percent;
              top: 91px*$percent;
            }
            .bg4{
              width: 112px*$percent;
              left: 140px*$percent;
              top: 147px*$percent;
            }
            .bg5{
              width: 66px*$percent;
              left: 129px*$percent;
              top: 192px*$percent;
            }
            .bg6{
              width: 125px*$percent;
              left: 244px*$percent;
              top: 166px*$percent;
            }
            *{

              /*border:1px red solid;*/
            }
          }

          .dashed_line{
            width: 202px*$percent;
            height: 20px*$percent;
            border-bottom:  2px dashed #104248;
            position:absolute;
            left: 261px*$percent;
            top: 116px*$percent;
          }
        }
      }
    }

    .panel7 {
      display: block;
      height:(606px-120px)*$percent;
      background: #ECECEB;
      padding-top: 120px*$percent;
      img {
        width:36px*$percent;
      }
      h1 {

        font-weight: 400;
        font-size: 24px*$percent;
        line-height: 48px*$percent;
        color:#2C2C2C;
        text-align: center;
        letter-spacing: 3px*$percent;
        span {
          font-size: 24px*$percent;
          line-height: 48px*$percent;
          font-weight: 700;
        }
      }
      p {
        text-align: center;
        font-size: 16px*$percent;
        -webkit-transform: scale($percent);
        color:#2C2C2C;
        line-height: 16px;
        margin-top: 38px*$percent;
        margin-bottom: 37px*$percent;
      }
      .box {
        width: 625px*$percent;
        height: 400px*$percent;
        position: relative;
        margin:0 auto;
        .leftbox, .rightbox {

          position: absolute;

          width:284px;
          overflow: visible;
          div {
            margin-bottom: 28px*$percent;
            text-align: center;
          }
          h2{
            text-align: center;
            font-size: 16px*$percent;
            line-height: 1.5;
          }
          p {
            width: 100%;
            font-size: 16px*$percent;
            -webkit-transform: scale($percent);
            margin:20px*$percent 0 0 0;
            text-align: left;
            line-height: 20px*$percent;
            letter-spacing: 2px*$percent;
          }
          span {
            display: block;
            text-align: left;
            font-size: 27px*$percent;
            line-height: 27px*$percent;
            vertical-align: top;
            margin-top: 5px*$percent;
          }
        }


        .leftbox {
          left: 0;
          span {
            text-align: center;
            color:rgb(46,215,151);
          }
        }
        .rightbox {
          right: 0;
          span {
            text-align: center;
            color:rgb(247,58,58);
          }
        }
      }
    }

    .panel9 {
      background-color: rgb(243,243,243);
      text-align: center;
      height:606px*$percent;
      overflow: hidden;
      .bg {
        background: url(../static/images/text_DIGITAL.png),url(../static/images/text_STRATEGY.png);
        background-repeat: no-repeat,no-repeat;
        background-size: auto 66px*$percent, auto 66px*$percent;
        background-position: 435px*$percent 306px*$percent, 1021px*$percent 306px*$percent;
        width:1920px*$percent;
        height:606px*$percent;
        height:100%;
        display: inline-block;
        margin:0 -50%;
        overflow: visible;
        img {
          width:39px*$percent;
          margin-right: 10px*$percent;
        }
        h1 {
          display: inline-block;
          margin-top: 72px*$percent;
          color:rgb(45,45,45);
          font-size: 24px*$percent;
          line-height: 68px*$percent;
          text-align: center;
          letter-spacing: 3px*$percent;
          position: relative;
          z-index: 1;
          &:after {
            position:absolute;
            content:' ';
            border:8px*$percent solid #e3e3e2;
            width:102px*$percent;
            height:52px*$percent;
            top:0;
            left:6px*$percent;
            z-index: -1;
          };
        }
        .msg {
          color: rgb(148,148,148);
          text-align: center;
          font-size: 12px*$percent;
          line-height: 16px;
          -webkit-transform: translateY(($percent - 1)/2*100%) scale($percent);
          margin-top: 28px*$percent;
        }
        ul {
          margin-top: 53px*$percent;
          li {
            -webkit-transform: translateY(($percent - 1)/2*100%) scale($percent);
            position: relative;
            img {
              position: absolute;
              bottom:26px;
              left:106px;
              width:52px;
              margin:20px 0 0 0;
            }
          }
          li:nth-child(1) .box img {
            width:22px;
          }
          li:nth-child(2) .box img {
            width:26px;
            margin-top: 30px;
          }
          li:nth-child(3) .box img {
            width:23px;
          }
          .box {
            border:1px solid #c3c3c3;
            background-color: white;
            margin:0 15px;
            width:226px;
            height:226px;
            text-align: center;
            img {
              position: static;
            }
            p {
              font-size: 12px;
              line-height: 16px;
              color:#2D2D2D;
              text-align: justify;
              margin-top: 13.25px;
              padding:0 24px;
              letter-spacing: 1px;
            }
          }
          h2 {
            font-size: 14px;
            color:#2D2D2D;
            margin-top: 29px;
          }
        }
      }
    }

    .panel2{
      display: inline-block;
      margin:0 -50%;
      width: 1920px*$percent;
      height: 607px*$percent;
      position: relative;
      background-color: #ececeb;
      text-align: center;
      .pic{
        background: url('../static/images/com_index_2fig.png') center center no-repeat;
        $padding_right:7px;
        background-size: cover;
        width: (585px-$padding_right)*$percent;
        padding-right:$padding_right*$percent; 
        height: 350px*$percent;
        position: absolute;
        left: 0;right: 0;
        margin: 0 auto;
        top: 172px*$percent;
        overflow: hidden;
        div.txt_box{
          width: 286px*$percent;
          height: 340px*$percent;
          overflow: hidden;
          position: relative;
          margin:0 auto;

          div.swiper-container5{
            position: relative;
            top: 142px*$percent;
            width: 100%;
            height: 100px*$percent;
            color: #fff;

            div.swiper-wrapper{
              flex-wrap:nowrap;
              div.swiper-slide{
                width: 100%;
                height: 100%;
                text-align: left;

                color:inherit;
                h2{
                  font-size:14px*$percent;
                  line-height: 1;
                  width: 255px*$percent;
                  margin:0 auto;
                  position: relative;
                }
                p{
                  position: relative;
                  width: 255px*$percent;
                  font-size: 12px*$percent;
                  top: 16px*$percent;
                  line-height: 1.4;
                  margin:0 auto;
                  letter-spacing: 2px*$percent;
                }
              }
            }
          }
        }
      }
      h1{
        font-size: 24px*$percent;
        line-height: 24px*$percent;
        color: #000205;
        position:relative;
        top: 78px*$percent;
        letter-spacing: 7px*$percent;
      }
      .main{
        position: relative;
        p{
          font-size: 14px*$percent;
          line-height: 32px*$percent;
          color: #000205;
          letter-spacing: 3px*$percent;
          span{
            font-weight: bold;
            font-size: 14px*$percent;
            color: #4494fb;
            &:hover{
              cursor:pointer;
            }
          }
        }
      }
      .top{
        top: 102px*$percent;
      }
      .bottom{
        top: 353px*$percent;
      }
    }
    .panel4{
      overflow: hidden;
      display: inline-block;
      margin:0 -50%;
      width: 1920px*$percent;
      height: 690px*$percent;
      position: relative;
      text-align: center;
      .linechart{
        position: relative;
        width: 932px*$percent;
        height: 504px*$percent;
        top: 188px*$percent;
        margin:0 auto;
      }
      .center{
        width: 283px*$percent;
        height: 175px*$percent;
        position: absolute;
        top: 131px*$percent;
        left: 500px*$percent;
        h2{
          text-align: left;
          color: #242424;
          font-size: 24px*$percent;
          line-height: 20px*$percent;
          letter-spacing: 2px*$percent;
          padding-bottom:15px*$percent; 
          border-bottom:2px*$percent dashed #104248; 
        }
        p{
          letter-spacing: 2px*$percent;
          text-align: justify;
          font-size: 16px*$percent;
          line-height: 1.5;
          color: #2d2d2d;
          margin:21px*$percent 0 7px*$percent;
        }
      }
    }
    .panel6{
      position: relative;
      background: url('../static/images/com_index_6bg.jpg') no-repeat center center;
      background-size: cover;
      display: inline-block;
      margin:0 -50%;
      width: 1920px*$percent;
      overflow:visible;
      height: 606px*$percent;
      color: #fff;
      .title{
        position: relative;
        top: 100px*$percent;

        h2{
          font-size: 24px*$percent;
          line-height: 24px*$percent;
        }
        p{
          margin-top: 10px*$percent;
          font-size: 12px*$percent;
          -webkit-transform: scale($percent);
          line-height: 16px;
        }
      }
      ul{
        width: 577px*$percent;
        position: absolute;
        left: 0;right: 0;
        margin:0 auto;
        top: 180px*$percent;
        li{
          text-align: center;
          h2{
            margin-top: 38px*$percent;
            font-size: 16px*$percent;
            font-weight:bold;
          }
          &:last-child {
            -webkit-transform: scale($percent);
          };
          p{
            margin-top: 13px*$percent;
            letter-spacing: 3px*$percent;
            line-height: 1.5;
            font-size: 16px*$percent;
            -webkit-transform: scale($percent);
            text-align: justify;
            strong{
              font-size: 16px*$percent;
              color: #4494fb;
              font-weight:bold;
              &:hover{
                cursor: pointer;
              }
            }
          }
          div{
            position: relative;
            top: 40px*$percent;
            $span_width:70px*$percent;
            span{
              position: absolute;
              left: 0;
              font-size: 16px*$percent;
              line-height: 1.5;
              font-weight:bold;
              color: #fffffe;
              width: $span_width;
              text-align: left;
            }
            div{
              position: absolute;top: 0;
              right: 0;
              letter-spacing: 3px*$percent;
              font-size: 16px*$percent;
              line-height: 1.5;
              width: 577px*$percent - $span_width;
              text-align: left;
            }
          }
          #connect_node{
            visibility: hidden;
          }
        }
      }
    }
    .panel8{
      position: relative;
      background: url('../static/images/com_index_8bg.jpg') no-repeat center center;
      background-size: cover;
      display: inline-block;
      margin:0 -50%;
      width: 1920px*$percent;
      overflow:visible;
      height: 606px*$percent;
      color: #fff;
      .txt_box{
        width: 643px*$percent;
        height: 281px*$percent;
        position: absolute;
        left: 0;right: 0;
        margin: 0 auto;
        top: 176px*$percent;
        h1{
          font-size: 24px*$percent;
          line-height: 1.6;
          position: absolute;
          top: 0px*$percent;
          left: 0*$percent;
          white-space: pre-line;
          font-weight: bold;
          text-align: left;
        }
        
        div p{
          font-size: 16px*$percent;
          line-height: 2;
          font-weight: bold;
          text-align: left;
          letter-spacing: 2.3px*$percent;
          width: 643px*$percent;
          margin: 10px*$percent 0;
          opacity: 0;
          &.active {
            &:nth-child(1) {
              animation: show6 0.5s;
              animation-direction:alternate;
              animation-timing-function: linear;
              animation-delay: 0;
              animation-fill-mode: forwards;
            };
            &:nth-child(2) {
              animation: show6 0.4s;
              animation-direction:alternate;
              animation-timing-function: linear;
              animation-delay: 0.5s;
              animation-fill-mode: forwards;
            };
            &:nth-child(3) {
              animation: show6 0.4s;
              animation-direction:alternate;
              animation-timing-function: linear;
              animation-delay: 1s;
              animation-fill-mode: forwards;
            };
            &:nth-child(4) {
              animation: show6 0.4s;
              animation-direction:alternate;
              animation-timing-function: linear;
              animation-delay: 1.5s;
              animation-fill-mode: forwards;
            };
            &:nth-child(5) {
              animation: show6 0.4s;
              animation-direction:alternate;
              animation-timing-function: linear;
              animation-delay: 2s;
              animation-fill-mode: forwards;
            };
          }
          
        }
        .main{
          position: absolute;
          -webkit-transform: scale($percent);
          -webkit-transform: translate(($percent - 1)/2*100%,($percent - 1)/2*100%) scale($percent);
          left: 0*$percent;
          top: 50px*$percent;
          width: 560px*$percent;
        }

      }
    }
    .phoneShow {
      display: none;
    }
  }
  /* pc */
  @media screen and (min-width:1080px) {
    @include global()
  }
  /* pad */
  @media screen and (max-width:1079px) and (min-width: 800px){
    @include global(800/1060);
    #line_chart{
      -webkit-transform: scale(0.4) translate(-75%, -85%);
      -ms-transform: scale(0.4) translate(-75%, -85%);
      -o-transform: scale(0.4) translate(-75%, -85%);
      transform: scale(0.4) translate(-75%, -85%);

    }
    .panel2 .pic div.txt_box div.swiper-container5 div.swiper-wrapper div.swiper-slide{
      p,h2{
        font-size: 12px;
      }
      -webkit-transform: scale(0.9);
      -ms-transform: scale(0.9);
      -o-transform: scale(0.9);
      transform: scale(0.9);
    }
    .panel2 .pic div.txt_box div.swiper-container5{
      top: 96px;
    }
  }
  @media screen and (max-width:799px) {
    .panel6{
      position: relative;
      background: url('../static/images/com_index_6bg.jpg') no-repeat center center;
      background-size: cover;
      display: inline-block;
      width: 1920px;
      overflow:visible;
      height: 606px;
      color: #fff;
      .title{
        position: relative;
        top: 100px;

        h2{
          font-size: 24px;
          line-height: 24px;
        }
        p{
          margin-top: 10px;
          font-size: 12px;
          line-height: 16px;
        }
      }
      ul{
        width: 432px;
        position: absolute;
        left: 0;right: 0;
        margin:0 auto;
        top: 180px;
        li{
          text-align: center;
          h2{
            margin-top: 38px;
            font-size: 14px;
            font-weight:bold;
          }
          &:last-child {
          };
          p{
            margin-top: 13px;
            letter-spacing: 3px;
            line-height: 16px;
            font-size: 12px;
            strong{
              padding-top: 38px;
              font-size: 14px;
              color: #4494fb;
              font-weight:bold;
            }
          }
          div{
            position: relative;
            top: 40px;
            $span_width:65px;
            span{
              position: absolute;
              left: 0;
              font-size: 14px;
              font-weight:bold;
              color: #fffffe;
              width: $span_width;
            }
            div{
              position: absolute;top: 0;
              right: 0;
              letter-spacing: 3px;
              line-height: 16px;
              font-size: 12px;
              width: 432px - $span_width;
              text-align: left;
            }
          }
        }
      }
    }
    .panel8{
      position: relative;
      background: url('../static/images/com_index_8bg.png') no-repeat center center;
      background-size: cover;
      display: inline-block;
      margin:0 -50%;
      width: 1920px;
      overflow:visible;
      height: 606px;
      color: #fff;
      .txt_box{
        width: 951px;
        height: 281px;
        background-color: rgba(22,22,22,0.6);
        position: absolute;
        left: 0;right: 0;
        margin: 0 auto;
        top: 136px;
        h1{
          font-size: 24px;
          position: absolute;
          top: 30px;
          left: 50px;
          white-space: pre-line;
          text-align: left;
        }
        div p{
          font-size: 12px;
          line-height: 24px;
          white-space: pre-line;;
          text-align: left;
          letter-spacing: 1.3px;
        }
        .left{
          position: absolute;
          left: 50px;
          top: 144px;
          width: 560px;
        }
        .right{
          position: absolute;
          width: 412px;
          top: 184px;
          left: 580px;
        }

      }
    } 
    .panel4{
      margin:0 -50%;
      width: 1920px;
      height: 608px;
      position: relative;
      text-align: center;
      .swiper-container2 {
        overflow: hidden;
      }
      .linechart{
        position: relative;
        width: 972px;
        top: 47px;
      }
      .center{
        width: 259px;
        height: 175px;
        position: absolute;
        top: 67px;
        left: 500px;
        h2{
          text-align: left;
          color: #242424;
          font-size: 24px;
          line-height: 20px;
          letter-spacing: 2px;
        }
        p{
          letter-spacing: 2px;
          text-align: left;
          font-size: 14px;
          color: #2d2d2d;
          margin:21px 0 7px;

        }
      }
    }
    .container {
      overflow: hidden;
    }
    .panel,.panel1, .panel2, 
    .panel3, .panel4, .panel5, 
    .panel7, .panel8,
    .panel9 {
      position: relative;
      height: auto;
    }

    .panel1 {
      background: url(../static/images/com_index_01bg.jpg) no-repeat center center;
      background-size: cover;
      position: relative;
      height:100vh;
      div{
        overflow: visible;
      }

      h1 {
        font-size: 17px;
        text-align: center;
        position: relative;
        top:-25px;
        color:white;
        letter-spacing: 2px;
        padding-bottom: 10px;
        color:#F1F6FF;
        text-shadow:3px 4px 23px rgba(255,255,255,0.7),
        -3px -4px 20px rgba(255,255,255,0.7);
        overflow: visible;
        font-weight: normal;
        margin-bottom: 5px;
      }
      h2 {
        position: relative;
        text-align: center;
        top: -31px;
        font-size: 21px;
        line-height: 1.5;
        color:white;
        letter-spacing: 2px;
        padding-bottom: 3px;
        color:#F1F6FF;
        text-shadow:3px 4px 23px rgba(255,255,255,0.7),
        -3px -4px 20px rgba(255,255,255,0.7);
        overflow: visible;
        font-weight: normal;
        margin-bottom: 6px;
      }
      img {
        width:80%;
      }
      .note {
        font-size: 12px;
        line-height: 16px;
        position: absolute;
        bottom:8px;
        left:0;
        right: 0;
        p {
          padding:5px 0;
          text-align: center;
          color:white;
          &:last-child {
            padding-bottom:42px;
          };
        }
      }
    }
    .panel3 {
      *{
        -webkit-flex-wrap:nowrap;
        flex-wrap:nowrap;
      }
      $panelHeight:550px;
      height: $panelHeight;
      background: #23272b;
      position: relative;
      .leftbox {
        background: url(../static/images/com_index_03bg.jpg) no-repeat center center;
        width: 100%;
        height: 230px;
        background-size: cover;
        text-align: center;
        position: relative;
        padding:45px 0 20px 0;
        margin-top: 0;
        &:after {
          position:absolute;
          content: ' ';
          height:2px;
          width:64px;
          background: #4494FB;
          bottom:0;
          left:50%;
          margin-left: -32px;
        };
        h2 {
          display: inline-block;
          font-size: 16px;
          color:rgb(58,247,178);
          line-height: 42px;
          letter-spacing: 3px;
          margin:0 auto 30px;
          padding:0 20px;
          position: relative;
          font-weight: 400;
          z-index: 1;
          border:4px solid rgba(155,195,222,0.18);
        }
        p {
          width: 90%;
          text-align: left;
          position: relative;
          margin: 0 auto;
          font-size: 13px;
          color:white;
          padding-bottom: 20px;
          letter-spacing: 2px;
          line-height: 18px;
        }
      }
      .rightbox {

        height:$panelHeight - 300px;
        &.phoneShow {
          display: none;
        }
        ul {
          .item {
            float:left;
            width:100%;
            text-align: left;
            -webkit-box-pack: start;
            -webkit-justify-content: flex-start;
            -ms-flex-pack: start;
            justify-content: flex-start;
            .a1900 {
              background: url(../static/images/icon1.png) no-repeat 20px top;
              background-size: 30px 29px;
              margin-top: 38px;
            }
            .a1960 {
              background: url(../static/images/icon2.png) no-repeat 20px top;
              background-size: 30px 29px;
              margin-top: 38px;
            }
            .a1990 {
              background: url(../static/images/icon3.png) no-repeat 20px top;
              background-size: 32px 29px;
              margin-top: 38px;
            }
            .a2010 {
              background: url(../static/images/icon4.png) no-repeat 20px top;
              background-size: 32px 29px;
              margin-top: 38px;
            }
            .box {
              float:left;
              padding-left: 60px;
              padding-right: 20px;

              p {
                font-size: 12px;
                margin-top: 14px;
                margin-bottom: 10px;
                line-height: 20px;
                color:white;
              }
              & h3 {
                position: relative;
                font-size: 15px;
                color:white;
                padding-bottom: 10px;
                &:after {
                  position: absolute;
                  bottom: 0;
                  left: 1px;
                  width: 27px;
                  content: ' ';
                  height: 1px;
                  background-color: #4494FB;
                  -webkit-transform: scaleY(.5);
                }
              }
              ul {
                list-style-type:disc;
                list-style-position:inside;
                color: white;
                li {
                  width: 100%;
                  font-weight: 700;
                  font-size: 12px;
                  line-height: 16px;
                  letter-spacing: 1px;
                }
              }
            }
          }
        }
      }
    }



    .panel5 {
      background:#cad7d6;
      padding:70px 20px 60px;
      img {
        width:100%;
      }
    }
    .panel7 {
      .bg {
        position: relative;
        width:auto;
        height:100%;
        margin:0 auto;
        overflow: visible;
        .centerPart {
          display: none;
        }
        .center {
          position: relative;
          top:0;
          right:0;
          left:0;
          bottom:0;
          z-index: 3;
          color:black;
          img {
            width:24px;
            margin-right: 10px;
          }
          h1 {
            position: relative;
            font-size: 18px;
            line-height: 24px;
            text-align: center;
            margin-top: 0px;
            padding-top: 96px;
            .phoneShow {
              position: absolute;
              top:76px;
              left:50%;
              margin-left: -115px;
              display:block;
              width:214px;
              height:70px;
              border: 8px solid rgba(152,194,220,0.18);
            }
          }
          p {
            position: relative;
            text-align: center;
            font-size: 13px;
            width:272px;
            line-height: 18px;
            margin: 35px auto 0;
            padding-bottom: 45px;
            &.phoneShow:after {
              position: absolute;
              bottom:0;
              left:50%;
              margin-left: -32px;
              width: 64px;
              content:' ';
              height:2px;
              background-color: #313131;
            }   
          }
          .box {

            width: 100%;
            height: 210px;
            margin:0 auto;
            background-color: #f3f3f3;
            *{
              -webkit-flex-wrap:nowrap;
              flex-wrap:nowrap;
            }
            .swiper-wrapper6{
              height: 100%;
            }
            .swiper-wrapper{
              height: 100%;
              .leftbox, .rightbox {
                text-align: center;
                position: relative;
                width:100%;
                padding:0 20px;
                overflow: visible;
                height: 100%;
                div {
                  display: inline-block;
                  text-align: left;
                  position: relative;
                  top: 41px;
                  margin:0 auto;
                  overflow: visible;
                  padding-bottom: 5px;
                }
                p {
                  position: relative;
                  top:30px;
                  margin:10px auto 0;
                  padding:0 0 0 0;

                  line-height: 20px;
                  width: 85%;
                  letter-spacing: 1px;
                  text-align: center;
                }
                span {
                  font-size: 22px;
                  line-height: 24px;
                  vertical-align: top;
                }
              }


              .leftbox {
                span {
                  color:rgb(58,247,178);
                }
                .textPic {
                  position: absolute;
                  bottom: auto;
                  top:136px;
                  width: auto;
                  height: 25px;
                  left: 0;right: 0;
                  margin:0 auto;

                }
              }
              .rightbox {
                span {
                  color:rgb(247,58,58);
                }
                .textPic2 {
                  position: absolute;
                  bottom: auto;
                  top:155px;
                  width: auto;
                  height: 25px;
                  left: 0;right: 0;
                  margin:0 auto;
                }
              }
            }
          }
        }
      }
    }
    .panel9 {
      background-color: white;
      .bg {
        position: relative;
        width:100%;
        height:auto;
        position: relative;
        color:white;
        img {
          width:39px;
          margin-right: 10px;
        }
        h1 {
          display: table;
          color:rgb(49,49,49);
          font-size: 16px;
          line-height: 16px;
          text-align: center;
          margin:60px auto 10px;
          padding:14px 20px;
          border: 4px solid rgba(212, 212, 212, 0.18);
        }
        p {
          color: rgb(147,147,147);
          text-align: center;
          font-size: 12px;
          line-height: 23px;
          letter-spacing: 1px;
          margin: 0px auto 55px;
          padding:0 32px;
        }
        .swiper-container1 {
          width: 100%;
          overflow: hidden;
          background-color: #f3f3f3;
          .swiper-wrapper {
            -webkit-flex-wrap:nowrap;
            flex-wrap:nowrap;
          }
          .swiper-wrapper {
            padding:60px 0;
            height: auto;
            width:100%;
          }
          .item {
            margin-top: 0px;
            height:auto;
            width: 80%;
            overflow: visible;
            position: relative;
            img {
              position: absolute;
              bottom:30px;
              left:50%;
              width:60px;
              margin:20px 0 0 -30px;
            }
            .box1 img {
              width:30px !important;
            }
            .box2 img {
              width:32px;
              margin-top: 30px;
            }
            .box3 img {
              width:28px;
            }
            .box {
              border:1px solid #c3c3c3;
              background-color: white;
              margin:0 10px;
              height:225px;
              text-align: center;
              img {
                position: static;
                margin-left: 0;

              }
              p {
                font-size: 13px;
                color:#313131;
                text-align: left;
                margin: 13.25px 0 16px;
                padding:0 18px;
                letter-spacing: 1px;
                line-height: 16px;
              }
            }
            h2 {
              font-size: 15px;
              color:#313131;
              margin-top: 40px;
            }
          }
        }
      }
    }
    .panel2 {
      background-color:#fff;
      margin:0;
      padding: 0;
      height: 2.87rem;
      width: 100%;
      position: relative;
      .textPic,.textPic2 {
        display: none;
      }
      .entrance_phone{
        width: 3.36rem;
        position: relative;
        top: 0.43rem;
        margin:0 auto;
        height: auto;
        h2{
          font-size: 0.16rem;
          color: #3a97f7;
          line-height: 0.50rem;
          text-align: center;
          span{
            position: absolute;
            margin: 0 auto;
            left: 0; right: 0;
            width: 2.20rem;
            height: 0.50rem;
            border: 0.04rem solid rgba(0,0,0,0.12);
            box-sizing:border-box;

          }
        }
        p{
          position: relative;
          top: 0.31rem;
          color: #313131;
          letter-spacing: 0.005rem;
          font-size: 0.13rem;
          line-height: 0.20rem;
          strong{
            font-size: 0.13rem;
            color: #3a97f7;
            font-weight: normal;

          }
        }
        .exp_phone,.dig_exp_phone{
          overflow: visible;
          display: none;
          position: absolute;
          top:1.25rem;
          width: 3.34rem;
          height: 1.17rem;
          background-color: rgba(122,122,122,0.85);
          .theme{
            padding-left: 0.20rem;
            height: 0.37rem;
            border-bottom:0.01rem solid #fefeff; 
            color: #fefefe;text-align: left;
            line-height: 0.36rem;
            font-weight: normal;
          }
          .main{
            position: absolute;
            height: 0.80rem;
            bottom: 0;
            width: 100%;
            p{
              padding-top: 0.12rem;
              display: inline-block;
              width: 2.94rem;
              height: auto;
              color: #fefefe;
              position: absolute;
              top: 0;bottom: 0;right: 0;left: 0;
              margin:  auto;
            }

          }

          &:after{
            position: absolute;
            content:'';
            width: 0;
            height: 0;
            top: -0.18rem;
            left: 1.18rem;
            border-top: 0.1rem solid transparent;
            border-left:0.08rem solid transparent;
            border-right:0.08rem solid transparent;
            border-bottom:0.1rem solid rgba(122,122,122,0.85);
          }
        }
        .exp_phone{

        }
        .dig_exp_phone{
          .main{
            p{
              line-height: 1.1;
            }
          }
          &:after{
            left: 2.6rem;
          }
        }
      }
    }

    .panel4 {/*原先PC 页的样式*/

      position: relative;
      width:1060px;
      /*height:100%;*/
      margin:0 auto;
      overflow: visible;
      .phoneShow {
        display: none;
      }
      .centerPart {
        position: absolute;
        top:0;
        right:0;
        left:0;
        bottom:0;
        z-index: 2;
        .textPic {
          position: absolute;
          bottom: 181px;
          width: 477px;
          right: 0;
        }
        .square {
          position: absolute;
          width: 171.37px;
          top: 57.42px;
          left: 48px;
        }
        .linePic {
          position: absolute;
          width: 1022px;
          bottom: 53.88px;
          right:0;
        }
      }
      .center {
        position: absolute;
        top:0;
        right:0;
        left:0;
        bottom:0;
        z-index: 3;
        color:black;
        h2 {
          font-size: 25px;
          margin-top: 85px;
          color: rgb(58,151,247);
          margin-bottom: 61.75px;
        }
        p {
          position: relative;
          font-size: 15px;
          width:312px;
          letter-spacing: 2px;
          padding-bottom: 10px;
        }
        p:nth-child(3) {
          padding-bottom: 15px;
          &:after {
            position: absolute;
            bottom:0;
            left:0;
            width: 58px;
            content:' ';
            height:2px;
            background-color: rgb(58,151,247);
          }
        }
      }

    }
    .panel4 {
      width:100%;
      height:auto;
      .centerPart {
        display: none;
      }
      .center {
        height: 225px;
        width: 90%;
        position: relative;
        margin:0 auto;
        text-align: center;
        color:black;
        h2 {
          display: inline-block;
          text-align: center;
          font-size: 16px;
          margin: 35px auto 15px;
          padding:12px 30px;
          border: 5px solid rgba(212, 212, 212, 0.18);
          color: rgb(58,151,247);
        }
        p {
          text-align: left;
          margin:0;
          font-size: 13px;
          line-height: 18px;
          width:auto;
          letter-spacing: 1px;
          padding:0 5px 8px;
        }
        p:nth-child(3):after {
          height:0;
        }
        &:after {
          position: absolute;
          bottom:0;
          left:50%;
          width: 64px;
          margin-left: -32px;
          content:' ';
          height:2px;
          background-color: rgb(69,220,199);
        }
      }
      .history {
        width:100%;
        background-color: #f3f3f3;
        overflow: hidden;
      }
      .phoneShow {
        position: relative;
        display: block;
        height:520px;
        overflow: hidden;
        .parallax-bg {
          position: absolute;
          left: 0;
          top: 0;
          width: 200%;
          height: 520px;
          -webkit-background-size: cover;
          background-image: url(../static/images/history.png);
          background-repeat: no-repeat;
          background-size: auto 100%;
          background-position: center  bottom;
        }
        .swiper-container2 {
          position: absolute;
          width:100%;
          top:0;
          bottom:0;
          .bg-line {
            position: absolute;
            bottom:38px;
            left:50%;
            margin-left: -1px;
            width:0px;
            height:320px;
            border-left:2px dashed #45dcc7;
          }
          .swiper-wrapper {
            -webkit-flex-wrap:nowrap;
            flex-wrap:nowrap;
          }
          .swiper-slide {
            width:100%;
            height:100%;
            overflow: hidden;
            .point {
              position: absolute;
              bottom:100px;
              left:50%;
              margin-left: -20px;
              display: inline-block;
              width:20px;
              height:20px;
              background-color: rgba(15,208,129,0.2);
              padding:10px;
              border-radius: 50%;
              .circle{
                display: inline-block;
                width:20px;
                height:20px;
                background-color: rgba(15,208,129,1);
                border-radius: 50%;
              }
            }
            .year {
              position: absolute;
              bottom:160px;
              right:50%;
              margin-right:25px;
              font-size: 15px;
              font-weight: 300;
            }
            .people {
              position: absolute;
              bottom:210px;
              left:50%;
              margin-left:25px;
              font-size: 15px;
              font-weight: 300;
            }
            .msg {
              position: absolute;
              width:110px;
              top:190px;
              right:50%;
              font-size: 15px;
              margin-right:20px;
            }
            .imgTitle {
              position: absolute;
              top:20px;
              left:50%;
              margin-left:-70px;
              width:140px;
            }
          }
        }
      }
    }
    div.panel6 {
      background-image: url('../static/images/com_index_06bg.jpg');
      height: 5.54rem;
      width: 100%;
      .title{
        color: #4494fb;
        text-align: right;
        top: 0.60rem;
        right: 0.20rem;
        h2{
          font-size: 0.20rem;
          letter-spacing: 0.01rem;
        }
        p{
          letter-spacing: 0.01rem;
          line-height: 0.15rem;
        }
        .box{
          position: absolute;
          top: -0.08rem;
          right: .40rem;
          border:.04rem solid rgba(68,148,251,0.25);
          width: 1.95rem;
          height: .58rem;
        }
      }
      ul{
        top: 1.30rem;
        width: 90%;
        li{
          text-align: left;
          h2{
            font-weight: bold;
            font-size: .16rem;
            margin-top: .30rem;
          }
          p{
            margin-top: .13rem;
            letter-spacing: 0.01rem;
            line-height: .2rem;
            font-size: .12rem;
            strong{
              padding:0;
              font-size: inherit;
              font-weight: inherit;
            }
          }
        }
        #panel6_connect_node_phone{
          display: none;
          position: relative;
          top:-0.2rem;
          height: 1.18rem;
          width: 3.34rem;
          background-color: rgba(122,122,122,0.85); 
          h2{
            border-bottom: 0.01rem #fefefe solid;
            height: 0.37rem;
            font-size: 0.145rem;
            line-height: 0.37rem;
            padding: 0 0.22rem;
          }
          p{
            padding: 0 0.22rem;
            font-size: 0.13rem;
            line-height: .2rem;

          }
          &:after{
            position: absolute;
            content:'';
            width: 0;
            height: 0;
            top: -0.19rem;
            left: 1.92rem;
            border-top: 0.1rem solid transparent;
            border-left:0.08rem solid transparent;
            border-right:0.08rem solid transparent;
            border-bottom: 0.1rem solid rgba(122,122,122,0.85);
          }
        }
      }
    }
    .panel8 {
      display: block;
      height: 550px;
      width: 100%;
      margin: 0;
      background: url('../static/images/com_index_08bg.jpg') no-repeat center center;
      background-size:cover;
      .txt_box{
        padding-right: 35px;
        width:100%;
        height: 100%;
        width: 90%;
        background-color: transparent;
        position: absolute;
        margin: auto; ;
        left: 0;right: 0;top: 0;bottom: 0;
        h1{
          top: 153px;
          font-size: 18px;
          left: 35px;
          line-height: 1.5;
          width: 90%;
        }
        ul{
          list-style-type: none;
          position: absolute;
          top: 221px;
          left: 5px;
          color: red;
          li {       
            width: 90%;
            font-size: 20px;
            text-align: left;
            margin: 10px 30px;
            p {
              line-height: 1.8;
              color: #fefefe;
              font-size: 14px;
            }
          }
        }

      }
    }
    .pcShow {
      display: none;
    }
  }
  @media screen and (max-width: 335px) {
    div.panel6 ul #panel6_connect_node_phone:after{
      left:0.02rem;
    }
  }

  

</style>



// WEBPACK FOOTER //
// Index.vue?1f2090bd